import {
  FETCH_INFO_REQUEST,
  FETCH_INFO_SUCCESS,
  FETCH_INFO_FAILURE,
  CREATE_INFO_REQUEST,
  CREATE_INFO_SUCCESS,
  CREATE_INFO_FAILURE,
  UPDATE_INFO_REQUEST,
  UPDATE_INFO_SUCCESS,
  UPDATE_INFO_FAILURE,
  DELETE_INFO_REQUEST,
  DELETE_INFO_SUCCESS,
  DELETE_INFO_FAILURE,
} from "./restaurantinfoActionType";
export const fetchInfoRequest = () => ({
  type: FETCH_INFO_REQUEST,
});
export const fetchInfoSuccess = (data, dataType) => ({
  type: FETCH_INFO_SUCCESS,
  payload: { data, type: dataType },
});
export const fetchInfoFailure = (error) => ({
  type: FETCH_INFO_FAILURE,
  payload: error,
});
export const createInfoRequest = () => ({
  type: CREATE_INFO_REQUEST,
});
export const createInfoSuccess = (data, dataType) => ({
  type: CREATE_INFO_SUCCESS,
  payload: { data, type: dataType },
});
export const createInfoFailure = (error) => ({
  type: CREATE_INFO_FAILURE,
  payload: error,
});
export const updateInfoRequest = () => ({
  type: UPDATE_INFO_REQUEST,
});
export const updateInfoSuccess = (data, dataType) => ({
  type: UPDATE_INFO_SUCCESS,
  payload: { data, type: dataType },
});
export const updateInfoFailure = (error) => ({
  type: UPDATE_INFO_FAILURE,
  payload: error,
});
export const deleteInfoRequest = () => ({
  type: DELETE_INFO_REQUEST,
});
export const deleteInfoSuccess = (data, dataType) => ({
  type: DELETE_INFO_SUCCESS,
  payload: { data, type: dataType },
});
export const deleteInfoFailure = (error) => ({
  type: DELETE_INFO_FAILURE,
  payload: error,
});